import { useRef, useState } from "react";
import { Upload, RefreshCw } from "lucide-react";
import { watchlistAPI } from "../services/api";

export const WatchlistCsvImport = ({ owner, onDone }) => {
  const fileRef = useRef(null);
  const [replace, setReplace] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (replace && !window.confirm("Remplacer toute la watchlist par ce fichier ? Les actions absentes du fichier seront retirées (une sauvegarde est gardée).")) return;
    setBusy(true); setMsg("");
    try {
      const r = await watchlistAPI.importCSV(owner, await file.text(), replace);
      if (r.status !== "ok") throw new Error(r.message);
      setMsg(replace
        ? `Watchlist remplacée : ${r.total} actions (${r.imported} nouvelles, ${r.removed} retirées). Notes en cours de calcul (~1 min).`
        : `${r.imported} actions ajoutées (${r.total} au total). Notes en cours de calcul (~1 min).`);
      onDone?.();
      setTimeout(() => onDone?.(), 90000);
    } catch (err) {
      setMsg(`Import impossible : ${err?.response?.data?.detail || err.message || "erreur"}`);
    }
    setBusy(false);
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="watchlist-csv-import">
      <div className="flex rounded-lg border border-slate-700/50 overflow-hidden text-[11px] font-bold">
        {[[true, "Remplacer"], [false, "Ajouter"]].map(([v, label]) => (
          <button key={label} onClick={() => setReplace(v)} data-testid={`csv-mode-${v ? "replace" : "merge"}`}
            className={`px-2.5 py-1 transition-colors ${replace === v ? "bg-violet-500/30 text-violet-200" : "bg-slate-800/40 text-slate-400 hover:bg-slate-700/40"}`}>
            {label}
          </button>
        ))}
      </div>
      <button onClick={() => fileRef.current?.click()} disabled={busy} data-testid="csv-import-btn"
        className="flex items-center gap-1 px-2.5 py-1 rounded-lg bg-violet-500/20 border border-violet-500/30 text-violet-300 text-xs hover:bg-violet-500/30 disabled:opacity-50 transition-colors">
        {busy ? <RefreshCw className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />} Import CSV
      </button>
      <input ref={fileRef} type="file" accept=".csv,text/csv" className="hidden" onChange={onFile} data-testid="csv-import-input" />
      {msg && <span className="text-[11px] text-slate-300 w-full" data-testid="csv-import-msg">{msg}</span>}
    </div>
  );
};
